import React from 'react';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { VariablesEditorProps } from '../../../../../types/testVendorRequest.types';

// Reusable variables editor list
const VariablesEditor: React.FC<VariablesEditorProps> = ({ names = [], values = {}, setValue }) => {
  const fieldNames = names.length ? names : Object.keys(values);
  return (
    <div>
      {fieldNames.length === 0 && (
        <Typography color='text.secondary'>
          No variables detected yet. Select a profile to seed from, or start typing to add overrides.
        </Typography>
      )}
      {fieldNames.map((name) => (
        <Grid container spacing={2} key={name} sx={{ alignItems: 'center', mb: 1 }}>
          <Grid size={{ xs: 12, lg: 4 }}>
            <FormLabel htmlFor={`var-${name}`} title={name} sx={{ display: 'block', overflowWrap: 'anywhere' }}>
              {name}
            </FormLabel>
          </Grid>
          <Grid size={{ xs: 12, lg: 8 }}>
            <TextField
              id={`var-${name}`}
              type='text'
              value={values[name] ?? ''}
              onChange={(e) => setValue(name, e.target.value)}
              slotProps={{ htmlInput: { 'data-testid': `var-${name}` } }}
            />
          </Grid>
        </Grid>
      ))}
    </div>
  );
};

export default VariablesEditor;
